import React, { useState, useEffect } from 'react';
import Web3 from 'web3';
import WalletConnectProvider from '@walletconnect/web3-provider';
import abi from '../abi.json';  // Ensure this path correctly points to your ABI file
import './MintComponent.css';   // Custom styling if needed
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const MintComponent = () => {
    const [web3, setWeb3] = useState(null);
    const [account, setAccount] = useState(null);
    const [contract, setContract] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [mintCost, setMintCost] = useState("Loading...");

    const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS;
    const infuraId = process.env.REACT_APP_INFURA_ID;

    useEffect(() => {
        if (web3 && account) {
            try {
                const mintContract = new web3.eth.Contract(abi, contractAddress);
                setContract(mintContract);
                console.log("Contract initialized:", mintContract);

                // Fetch mint price
                mintContract.methods.mintPrice().call()
                    .then(price => {
                        console.log("Fetched mint price (in Wei):", price);
                        const priceInEther = web3.utils.fromWei(price, 'ether');
                        console.log("Mint price in ETH:", priceInEther);
                        setMintCost(priceInEther);
                    })
                    .catch(error => {
                        console.error("Error fetching mint price:", error);
                        setMintCost("0.01"); // Use default mint price on failure
                    });
            } catch (initError) {
                console.error("Error initializing contract:", initError);
            }
        }
    }, [web3, account, contractAddress]);

    const connectMetaMask = async () => {
        if (window.ethereum) {
            try {
                await window.ethereum.request({ method: 'eth_requestAccounts' });
                const web3Instance = new Web3(window.ethereum);
                const accounts = await web3Instance.eth.getAccounts();
                setWeb3(web3Instance);
                setAccount(accounts[0]);
            } catch (error) {
                console.error("MetaMask connection error:", error);
            }
        } else {
            alert("MetaMask is not installed!");
        }
    };

    const connectWalletConnect = async () => {
        try {
            const provider = new WalletConnectProvider({ infuraId: infuraId });
            await provider.enable();
            const web3Instance = new Web3(provider);
            const accounts = await web3Instance.eth.getAccounts();
            setWeb3(web3Instance);
            setAccount(accounts[0]);
        } catch (error) {
            console.error("WalletConnect connection error:", error);
        }
    };

    const mintMultipleTokens = async () => {
        if (!contract || !account) {
            toast.error("Contract not loaded or wallet not connected!", { position: toast.POSITION.TOP_CENTER });
            return;
        }

        try {
            console.log(`Attempting to mint ${quantity} tokens...`);
            const cost = parseFloat(mintCost);
            if (isNaN(cost)) {
                toast.error("Mint cost is not a valid number.", { position: toast.POSITION.TOP_CENTER });
                return;
            }

            const valueInWei = web3.utils.toWei((cost * quantity).toFixed(18), 'ether');

            const response = await contract.methods.mintPublic(quantity).send({
                from: account,
                value: valueInWei,
                gas: 300000,
            });

            console.log("Transaction sent, awaiting confirmation...");

            // Check for transaction receipt
            web3.eth.getTransactionReceipt(response.transactionHash, (error, receipt) => {
                if (error) {
                    toast.error("Error fetching transaction receipt: " + error.message);
                } else if (receipt && receipt.status) {
                    toast.success("Minting successful!");
                } else {
                    toast.error("Minting failed, please try again.");
                }
            });

        } catch (error) {
            console.error("Error executing transaction:", error);
            if (error.message.includes("User denied")) {
                toast.info("Transaction was rejected. Please approve the transaction to proceed.");
            }
        }
    };

    return (
        <div className="mint-buttons">
            <ToastContainer />
            {account ? (
                <div>
                    <p>Connected as: {account}</p>
                    <p>Mint Cost per Token: {mintCost ? `${mintCost} ETH` : 'Loading...'}</p>
                    <div>
                        <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="mint-button">-</button>
                        <span>{quantity}</span>
                        <button onClick={() => setQuantity(Math.min(50, quantity + 1))} className="mint-button">+</button>
                    </div>
                    <button onClick={mintMultipleTokens} className="mint-button">
                        Mint {quantity} Tokens
                    </button>
                </div>
            ) : (
                <>
                    <button onClick={connectMetaMask} className="mint-button">Connect MetaMask</button>
                    <button onClick={connectWalletConnect} className="mint-button">Connect WalletConnect</button>
                </>
            )}
        </div>
    );
};

export default MintComponent;